import {ORDER_STATUS} from "@/constants"

export default {
    methods: {
        constraints_getProductTypeAvailableAmount(product, handleCart) {

            const constraints = handleCart
                ? this.$store.getters["user/constraints/cart"]
                : this.$store.getters["user/constraints/type"];

            return Math.min.apply(Math, product.product_type.map(type => constraints[type] ?? 0));
        },
        constraints_getProductAvailableAmount(product) {

            const constraints = this.$store.getters["user/constraints/type"];
            const cart = this.$store.getters["user/cart/items"];

            const resultConstraints = JSON.parse(JSON.stringify(constraints));

            // Handle cart items
            Object.keys(resultConstraints).forEach(type => {

                resultConstraints[type] -= cart.reduce((total, cartItem) => {

                    if (cartItem.sku !== product.sku) {

                        if (-1 !== cartItem.product_type.indexOf(type)) {

                            total += cartItem.quantity;
                        }
                    }


                    return total;
                }, 0);
            });

            return product.product_type.reduce((result, type) => {

                if (0 === result || result > resultConstraints[type]) {

                    result = resultConstraints[type];
                }

                return result;
            }, 0);
        },
        constraints_hasUserAvailableProducts(handleCart) {

            const constraints = handleCart
                ? this.$store.getters["user/constraints/cart"]
                : this.$store.getters["user/constraints/type"];

            return null !== constraints && 0 <= Object.keys(constraints).reduce(
                (result, type) => result + constraints[type],
                0
            );

        },
        constraints_filterAvailableProducts(products, handleCart = false, handleHistory = false) {

            const constraints = true === handleCart
                ? this.$store.getters["user/constraints/cart"]
                : this.$store.getters["user/constraints/type"];

            const productsHistory = this.$store
                .getters["user/orders/items"]
                .reduce((result, order) => result.concat(order.products), [])
                .filter(product => -1 === [ORDER_STATUS.CANCELED, ORDER_STATUS.RETURNED, ORDER_STATUS.TRANSFERRED].indexOf(product.status));

            return products
                .filter(item => {

                    if (true === handleHistory) {

                        if (null !== this.$store.getters["user/impersonatorToken"]) {

                            // We always show returned products for OOBO flow
                            // It needs to be under history block for correct handling cart functionality
                            return true;
                        }

                        if ("undefined" !== typeof item.allowed_to_order_reason) {

                            // item.allowed_to_order_reason it's a flag that product was available before and
                            // needs to be included
                            return true;
                        }

                        // Check for product in history has the same product or type. It's enough to display it
                        for (let i = 0; i < productsHistory.length; i++) {

                            if (productsHistory[i].sku === item.sku) {

                                return true;
                            }

                            for (let k = 0; k < productsHistory[i].productType.length; k++) {
                                for (let j = 0; j < item.product_type.length; j++) {
                                    if (item.product_type[j] === productsHistory[i].productType[k]) {

                                        return true;
                                    }
                                }
                            }
                        }
                    }

                    for (let i = 0; i < item.product_type.length; i++) {

                        if (!constraints[item.product_type[i]] || 0 >= constraints[item.product_type[i]]) {

                            return false;
                        }
                    }

                    return true;
                })
                .sort((a, b) => {

                    if (false === a.allowed_to_order && a.allowed_to_order !== b.allowed_to_order) {

                        return 1;
                    }

                    if (false === b.allowed_to_order && b.allowed_to_order !== a.allowed_to_order) {

                        return -1;
                    }

                    return 0;
                });
        },
        constraints_hasAnyAvailableProducts() {

            const constraints = this.$store.getters["user/constraints/cart"];

            return 0 < Object.keys(constraints).reduce((result, type) => result + constraints[type], 0);
        },
        constraints_refreshCartConstraints() {

            return this.$store.dispatch("user/constraints/fetchCart");
        }
    }
}